import { ACTION_TYPES } from '../../utils/Constants';
import { myLog } from '../../utils/Utility';

const MyPatientInfoReducer = (
    state = {
        patientInfoDetails: [],
        patientVisitListDetails: [],
        patientChatListDetails: [],
        patientEncounterSoapDetails: [],
        patientEncounterAllergiesDetails: [],
        patientEncounterPrescriptionsDetails: [],
        patientEncounterScreenShotsDetails: [],
        patientEncounterHandoutsDetails: [],
        patientEncounterComplaintImagesDetails: [],
        patientEncounterExcuseNoteDetails: {},
        EncounterDateArr: [],
        patientVisitId: 0,
        saveSoapDetails: '',
    },
    action = {}
) => {
    switch (action.type) {
        case ACTION_TYPES.PHYSICIAN.GET_PATIENT_INFO:
            state = {
                ...state,
                patientInfoDetails: action.payload,
            };
            break;
        case ACTION_TYPES.PHYSICIAN.GET_PATIENT_VISIT_LIST:
            state = {
                ...state,
                patientVisitListDetails: action.payload,
                patientVisitId: action.payload.visitId,
            };
            break;
        case ACTION_TYPES.PHYSICIAN.GET_FULL_PATIENT_VISIT_LIST:
            state = {
                ...state,
                patientFullVisitListDetails: action.payload,
                patientVisitId: action.payload.visitId,
            };
            break;
        case ACTION_TYPES.PHYSICIAN.DROPDOWN_SESSION:
            state = {
                ...state,
                DropDownSessionDetails: action.payload,
                patientVisitId: action.payload.visitId,
            };
            break;
        case ACTION_TYPES.PHYSICIAN.GET_PATIENT_CHAT_LIST:
            state = {
                ...state,
                patientChatListmessages: action.messages,
                patientChatListDetails: action.payload,
            };
            break;
        case ACTION_TYPES.PHYSICIAN.GET_PATIENT_VISIT_ENCOUNTER:
            myLog(action.payload.excusenote);
            state = {
                ...state,
                patientEncounterSoapDetails: action.payload.soapNotes,
                patientEncounterHandoutsDetails: action.payload.handouts,
                patientEncounterComplaintImagesDetails:
                    action.payload.soapNotes.visitComplaintImages,
            };
            break;
        case ACTION_TYPES.PHYSICIAN.REMOVE_PATIENT_SAVE_SOAP:
            myLog(action.payload.excusenote);
            state = {
                ...state,
                patientEncounterSoapDetails: action.payload,
                patientEncounterAllergiesDetails: action.payload,
                patientEncounterPrescriptionsDetails: action.payload,
                patientEncounterScreenShotsDetails: action.payload,
                patientEncounterHandoutsDetails: action.payload,
                patientEncounterComplaintImagesDetails: action.payload,
                patientEncounterExcuseNoteDetails: {},
            };
            break;
        case ACTION_TYPES.PHYSICIAN.GET_PATIENT_SAVE_SOAP:
            state = {
                ...state,
                saveSoapDetails: action.payload,
            };
            break;
        case ACTION_TYPES.PHYSICIAN.GET_ENCOUNTER_DATES_SUCESS:
            return {
                ...state,
                EncounterDateArr: action.payload,
            };

        default:
            break;
    }
    return state;
};
export default MyPatientInfoReducer;
